// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login_container__kakDl {

    height: 100vh;
  }
  
  .Login_box__oHDRG {
    padding: 20px 20px 60px 20px;
    background-color: #F3F4F6;
    margin-top: 4rem;
  }
  
  .Login_image__\\+ToX0 {
    width: 100%;
    max-width: 300px;
  }
  
  .Login_form__c4o7Y {
    width: 70%;
    margin-top: 10%;
  }
  
  .Login_textField__pBOah {
    margin-bottom: 20px;
  }
  
  .Login_links__pXoBw {
    margin-bottom: 20px;
  }

  .Login_links__pXoBw a{
    text-decoration: none!important;
    font-weight: 500;
  }
  
  .Login_button__mx3Qh {
    background-color: #C9D1D8!important;
    color: black;
    font-size: 12px!important;
    text-transform: none!important;
    border-radius: 5px!important;
    padding: 6px 30px!important;
    margin-top: 20px;
  }
  
  .Login_register__i85Qv {
    margin-top: 50px;
  }
  
  .Login_registerLink__-O0UQ {
    margin-left: 5px!important;
    text-decoration: none!important;
    font-weight: 500!important;
  }
  
  
  @media (max-width: 768px) {
    .Login_container__kakDl {
      padding-left: 20px;
      padding-right: 20px;
    }
  
    .Login_box__oHDRG {
      padding: 20px;
    }
  
    .Login_button__mx3Qh {
      margin-top: 15px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/component/login/Login.module.css"],"names":[],"mappings":"AAAA;;IAEI,aAAa;EACf;;EAEA;IACE,4BAA4B;IAC5B,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,+BAA+B;IAC/B,gBAAgB;EAClB;;EAEA;IACE,mCAAmC;IACnC,YAAY;IACZ,yBAAyB;IACzB,8BAA8B;IAC9B,4BAA4B;IAC5B,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,+BAA+B;IAC/B,0BAA0B;EAC5B;;;EAGA;IACE;MACE,kBAAkB;MAClB,mBAAmB;IACrB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,gBAAgB;IAClB;EACF","sourcesContent":[".container {\n\n    height: 100vh;\n  }\n  \n  .box {\n    padding: 20px 20px 60px 20px;\n    background-color: #F3F4F6;\n    margin-top: 4rem;\n  }\n  \n  .image {\n    width: 100%;\n    max-width: 300px;\n  }\n  \n  .form {\n    width: 70%;\n    margin-top: 10%;\n  }\n  \n  .textField {\n    margin-bottom: 20px;\n  }\n  \n  .links {\n    margin-bottom: 20px;\n  }\n\n  .links a{\n    text-decoration: none!important;\n    font-weight: 500;\n  }\n  \n  .button {\n    background-color: #C9D1D8!important;\n    color: black;\n    font-size: 12px!important;\n    text-transform: none!important;\n    border-radius: 5px!important;\n    padding: 6px 30px!important;\n    margin-top: 20px;\n  }\n  \n  .register {\n    margin-top: 50px;\n  }\n  \n  .registerLink {\n    margin-left: 5px!important;\n    text-decoration: none!important;\n    font-weight: 500!important;\n  }\n  \n  \n  @media (max-width: 768px) {\n    .container {\n      padding-left: 20px;\n      padding-right: 20px;\n    }\n  \n    .box {\n      padding: 20px;\n    }\n  \n    .button {\n      margin-top: 15px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Login_container__kakDl`,
	"box": `Login_box__oHDRG`,
	"image": `Login_image__+ToX0`,
	"form": `Login_form__c4o7Y`,
	"textField": `Login_textField__pBOah`,
	"links": `Login_links__pXoBw`,
	"button": `Login_button__mx3Qh`,
	"register": `Login_register__i85Qv`,
	"registerLink": `Login_registerLink__-O0UQ`
};
export default ___CSS_LOADER_EXPORT___;
